import { Dialog, type DialogProps } from '@shared/components';
import { useState } from 'react';

import {
  AddSingleQuestionConditionsFormProvider,
  AddSingleQuestionConditionsProvider,
  useAddSingleQuestionConditions,
} from '../../providers';
import type { ModalContentMapType } from '../../types';
import { AddSingleQuestionContent } from '../add-single-question-content';
import { SelectTopicContent, type SelectTopicContentProps } from '../select-topic-content';

export interface AddSingleQuestionConditionsModalProps extends DialogProps {
  chapterId: string;
  onClose: () => void;
  onSubmit?: () => void;
}

export default function AddSingleQuestionConditionsModal(
  props: Readonly<AddSingleQuestionConditionsModalProps>,
) {
  const { chapterId, onClose, onSubmit, open: isModalOpen } = props;
  const [modalContent, setModalContent] = useState<keyof ModalContentMapType>(
    'ADD_SINGLE_QUESTION_CONTENT',
  );

  const changeToAddSingleQuestionContent = () => {
    setModalContent('ADD_SINGLE_QUESTION_CONTENT');
  };

  return (
    <Dialog open={isModalOpen}>
      <AddSingleQuestionConditionsProvider chapterId={chapterId}>
        <AddSingleQuestionConditionsFormProvider>
          {modalContent === 'ADD_SINGLE_QUESTION_CONTENT' ? (
            <AddSingleQuestionContent
              onClose={onClose}
              onSubmit={onSubmit}
              setModalContent={setModalContent}
            />
          ) : null}
          {modalContent === 'SELECT_TOPIC_CONTENT' ? (
            <SelectTopicContentWithContext
              onClose={onClose}
              onBack={changeToAddSingleQuestionContent}
            />
          ) : null}
        </AddSingleQuestionConditionsFormProvider>
      </AddSingleQuestionConditionsProvider>
    </Dialog>
  );
}

function SelectTopicContentWithContext(
  props: Readonly<Pick<SelectTopicContentProps, 'onClose' | 'onBack'>>,
) {
  const { onClose, onBack } = props;
  const { chapterData, levelItemsWithLevel, checkExistOnStructures } =
    useAddSingleQuestionConditions();

  return (
    <SelectTopicContent
      mode='create'
      chapterData={chapterData}
      levelItemsWithLevel={levelItemsWithLevel}
      checkExistOnStructures={checkExistOnStructures}
      onClose={onClose}
      onBack={onBack}
    />
  );
}
